import { ProtocolPdfsStatus } from '../services/api';

/**
 * Podsumowanie hurtowego pobierania protokołów CEEB (E5) — jedno zdanie pod przyciskiem.
 *
 * Test akceptacyjny 2026-08-05: „Pobierz protokoły CEEB (8)" pobierało 3 pliki i NIE MÓWIŁO
 * NIC. Komunikat był warunkowany na `skipped`/`noUuidCount`, a oba liczą wyłącznie wiersze
 * `building_protocols`; budynek, który nigdy nie trafił do CEEB, nie ma tam ani jednego
 * wiersza, więc oba liczniki były zerowe i baner się nie pokazywał.
 *
 * Dlatego: podsumowanie jest BEZWARUNKOWE, a brakujące budynki liczy backend jako
 * `buildingsWithoutProtocol` (wskazane − te, dla których cokolwiek znaleziono).
 * Zwraca `null` tylko, gdy nie ma czego podsumowywać (brak statusu).
 */
export function protocolPdfsSummary(result: ProtocolPdfsStatus | null | undefined): string | null {
  if (!result) return null;
  const fetched = result.fetched ?? 0;
  // Komplet (#416, lista Bronka 12.10): jedno zdanie o całej zawartości + braki z pominiete.txt.
  if (result.include && result.include.length > 0) {
    const parts = [`Komplet pobrany: ${fetched} protokołów CEEB, ${result.summaries ?? 0} podsumowań, ${result.cards ?? 0} plików kart lokali (katalog na budynek).`];
    const missing = (result.skipped?.length ?? 0) + (result.extrasSkipped?.length ?? 0);
    if (missing > 0) parts.push(`Braki: ${missing} (lista w pominiete.txt w archiwum).`);
    return parts.join(' ');
  }
  // `allowed` = budynki, które faktycznie poszły do skryptu (po filtrze per-firma);
  // `requested` = zaznaczone w tabeli. Bez obu nie udajemy mianownika.
  const total = result.allowed ?? result.requested ?? null;
  const withProtocol = result.buildingsWithProtocol ?? null;

  const parts: string[] = [];
  if (total != null && withProtocol != null) {
    parts.push(`Pobrano protokoły dla ${withProtocol} z ${total} budynków (${fetched} plików w archiwum).`);
  } else {
    parts.push(`Pobrano protokoły (${fetched} plików w archiwum).`);
  }

  const without = result.buildingsWithoutProtocol ?? null;
  if (without != null && without > 0) {
    parts.push(`${without} budynków nie ma protokołu w CEEB.`);
  }
  const noUuid = result.noUuidCount ?? 0;
  if (noUuid > 0) {
    parts.push(`${noUuid} wpisów historii bez uuid — dociągnie je pełny import.`);
  }
  const skipped = result.skipped?.length ?? 0;
  if (skipped > 0) {
    parts.push(`${skipped} nieudanych pobrań (pominiete.txt w archiwum).`);
  }
  return parts.join(' ');
}
